var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "scrollable-container" },
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "8", sm: "6", md: "5", lg: "4", xl: "3" } },
            [
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c("v-img", {
                    staticClass: "light-round-image-border",
                    style: _vm.$vuetify.breakpoint.xs
                      ? "margin-top: 55px;"
                      : "margin-top: 55px;max-width: 371px;",
                    attrs: {
                      contain: "",
                      src: _vm.errorMessage.length
                        ? _vm.errorPageImage
                        : _vm.imageUrl,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-row", { attrs: { justify: "center" } }, [
        _c("h2", { staticClass: "pageTitle mt-5" }, [
          _vm._v(
            _vm._s(_vm.errorMessage.length ? _vm.errorPageTitle : _vm.title)
          ),
        ]),
      ]),
      _c("v-row", { attrs: { justify: "center" } }, [
        _vm.customErrorText.length
          ? _c("p", { staticClass: "pageText" }, [
              _vm._v(_vm._s(_vm.customErrorText)),
            ])
          : _vm.texts.length > 1
          ? _c("p", { staticClass: "pageText" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.errorMessage.length ? _vm.errorPageText : _vm.texts[0]
                  ) +
                  " "
              ),
              !_vm.errorMessage.length ? _c("br") : _vm._e(),
              _vm._v(
                " " + _vm._s(!_vm.errorMessage.length ? _vm.texts[1] : "") + " "
              ),
            ])
          : _c("p", { staticClass: "pageText" }, [
              _vm._v(
                _vm._s(_vm.errorMessage.length ? _vm.errorPageText : _vm.text)
              ),
            ]),
      ]),
      !_vm.noButtons
        ? _c(
            "v-row",
            {
              staticStyle: { "padding-bottom": "60px" },
              attrs: { justify: "center" },
            },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: _vm.button2Text.length ? 6 : 12 } },
                [
                  _c(
                    "v-row",
                    {
                      attrs: {
                        "justify-sm": _vm.button2Text.length ? "end" : "center",
                        justify: "center",
                      },
                    },
                    [
                      _vm.button2Text.length
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "pageButton",
                              class: {
                                "mr-2": _vm.$vuetify.breakpoint.smAndUp,
                              },
                              attrs: {
                                width: "200",
                                height: "52",
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("button2-clicked")
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.button2Text))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: _vm.button2Text.length ? 6 : 12 } },
                [
                  _c(
                    "v-row",
                    {
                      attrs: {
                        "justify-sm": _vm.button2Text.length
                          ? "start"
                          : "center",
                        justify: "center",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "pageButton",
                          class: {
                            "ml-2":
                              _vm.$vuetify.breakpoint.smAndUp &&
                              _vm.button2Text.length,
                          },
                          attrs: {
                            width: "200",
                            height: "52",
                            color: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("button-clicked")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.buttonText))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }